import { createBatchReleases } from "./createMockData/createBatchReleases";
import { defaulSelectedBatch } from "./batches";

export const batchReleases = createBatchReleases({
    batchid: defaulSelectedBatch.id
});
